import { useSearchParams } from 'hooks/use-search-params.hook';

/**
 * True only when the miniapp is embedded in tenant-portal's activity-center pane, signalled by an
 * explicit `activity-pane=true` marker on the URL (tenant-portal appends it).
 *
 * Read defensively on purpose: the activity pane and a real phone are both non-fullscreen and narrow,
 * so they're indistinguishable from here — only the explicit marker opts a view into the pane-specific
 * treatment. Missing/false ⇒ today's rendering, so a boot redirect that strips the param can only fall
 * back, never regress phone or desktop.
 */
export const useIsActivityPane = (): boolean => {
  const searchParams = useSearchParams<{ 'activity-pane'?: string }>();

  return searchParams?.['activity-pane'] === 'true';
};
